import axios from "axios";

// Criar nova live
export const createLive = async (liveData, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/createLive`,
      liveData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao criar live",
    };
  }
};

// Iniciar transmissão
export const startLive = async (liveId, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/startLive/${liveId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao iniciar live",
    };
  }
};

// Encerrar transmissão
export const endLive = async (liveId, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/endLive/${liveId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao encerrar live",
    };
  }
};

// Listar lives ativas
export const getActiveLives = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getActiveLives`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao buscar lives",
    };
  }
};

// Obter detalhes de uma live
export const getLive = async (liveId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getLive/${liveId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao buscar live",
    };
  }
};

// Histórico de lives de um usuário
export const getUserLives = async (userId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getUserLives/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao buscar histórico",
    };
  }
};

// Deletar live
export const deleteLive = async (liveId, token) => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/deleteLive/${liveId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao deletar live",
    };
  }
};

// Upload da gravação
export const uploadRecording = async (liveId, videoBlob, token, onProgress) => {
  try {
    const formData = new FormData();
    formData.append("video", videoBlob, `live_${liveId}_${Date.now()}.webm`);

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/uploadRecording/${liveId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress(percent);
          }
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao enviar gravação",
    };
  }
};

// Entrar na live (REST backup)
export const joinLive = async (liveId, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/joinLive/${liveId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao entrar na live",
    };
  }
};

// Sair da live (REST backup)
export const leaveLive = async (liveId, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/leaveLive/${liveId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao sair da live",
    };
  }
};

// Obter chat da live
export const getLiveChat = async (liveId, token, limit = 50) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getLiveChat/${liveId}?limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao buscar chat",
    };
  }
};

// Enviar mensagem no chat (REST backup)
export const sendChatMessage = async (liveId, message, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/sendLiveChat/${liveId}`,
      { message },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao enviar mensagem",
    };
  }
};

// Atualizar configurações da live
export const updateLiveSettings = async (liveId, settings, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/updateLiveSettings/${liveId}`,
      settings,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao atualizar configurações",
    };
  }
};

// Bloquear usuário da live
export const blockUserFromLive = async (liveId, userId, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/blockUserFromLive/${liveId}`,
      { userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao bloquear usuário",
    };
  }
};
